"use client";
import { useMemo } from "react";
import { useAuthQuery } from "@stadium/services/apollo-client";

import { fetchSavedCreditCardsAndWaletInfo } from "@stadium/checkout/src/graphql/queries/fetch-saved-cards-and-team-wallet-info";
import { isCreditCardExpired } from "@stadium/checkout/src/helpers/checkout";

const emptyArr = [];

const useFetchSavedCardsAndTeamWalletInfo = ({
  skip = false,
  skipCreditCards = false,
  skipWallets = false,
} = {}) => {
  const { data, error, loading, refetch } = useAuthQuery(fetchSavedCreditCardsAndWaletInfo, {
    fetchPolicy: "cache-and-network",
    variables: { skipCreditCards, skipWallets },
    skip,
  });

  const savedCreditCards = useMemo(() => {
    if (loading) return [];
    const cards = data?.creditCards || emptyArr;
    return cards.map((card) => ({
      ...card,
      isExpired: isCreditCardExpired(card),
    }));
  }, [loading, data]);

  const teamWallets = useMemo(() => {
    return loading ? [] : data?.teams || emptyArr;
  }, [loading, data]);

  return { loading, error: error?.message, teamWallets, savedCreditCards, refetch };
};

export default useFetchSavedCardsAndTeamWalletInfo;
